module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 myp",
    attrs: {
      "id": "ليلى"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عزيزي القارئ..")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كن واثقًا وتقدَّم، سلِّم نفسك لقلمي، واخطُ بخطاك إلى عالمي، لأرسم حولك فقاعة بيضاء، يكون الدخول والخروج منها أمرًا صعبًا.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تقدَّم وامضِ معي بين الصفحات، حيث الغزل يقابل اللعنات، حيث الواقع يحتضن الخيالات، حيث تكون أنتَ جزءًا مِن مملكتي..")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ومِن ممتلكاتي.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "text-align": "left"
    }
  }, [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ليلى")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 66
// module chunks = 0